const selectors = {
	container: '[js-featured-tabs="container"]'
}

document.addEventListener('DOMContentLoaded', () => {
	const node_selectors = {
		container: document.querySelector(selectors.container),
	}

	function initSlider() {
		if (!node_selectors.container) { return; }
		const swiper = new Swiper(selectors.container, {
			loop: false,
			slidesPerView: 3,
			spaceBetween: 10,
			centeredSlides: false,
		
			breakpoints: {
				768: {
					slidesPerView: 6,
					spaceBetween: 10,
				}
			}
		});
	}
	initSlider();

	var active_tab = document.querySelector('.tab-title.active');
	var active_category = active_tab.getAttribute("data-id");
	var category_name = '[data-category="' + active_category+'"]';
	var items = document.querySelectorAll(category_name);
	items.forEach(item => {
		item.classList.remove("hidden");
	});
	
	var tab_titles = document.getElementsByClassName("tab-title");

	var updateFaq = function() {
		var all_title = document.querySelectorAll('.tab-title');
		all_title.forEach(item => {
			item.classList.remove("active");
		});
		this.classList.add("active");
		var all_faq = document.querySelectorAll('.faq__accordion')
		all_faq.forEach(item => {
			item.classList.add("hidden");
		});
		var active_category = this.getAttribute("data-id");
		var category_name = '[data-category="' + active_category+'"]';
		var items = document.querySelectorAll(category_name);
		items.forEach(item => {
			item.classList.remove("hidden");
		});
	};

	for (var i = 0; i < tab_titles.length; i++) {
		tab_titles[i].addEventListener('click', updateFaq, false);
	}
	
});